import * as React from 'react';
import axios from "axios";
import { clsx } from 'clsx';
import { useContext, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import { inputErrorClass } from "../helpers/form";
import { isFunction } from "../helpers/utils";
import { ContextUrls } from "../state/contextUrlApi";
import type { AssetData } from "./asset.interface";

type Inputs = {
	filename: string
	description: string
}

type Props = {
	asset: AssetData,
	onAfterSave?: Function,
	handleClose?: Function,
}

function AssetEdit({asset, onAfterSave = null, handleClose = null, ...props}: Props) {
	const urls = useContext(ContextUrls);

	const {
		register,
		setValue,
		handleSubmit,
		formState: {
			errors,
			isSubmitting
		}
	} = useForm<Inputs>();

	const form = useRef(null);

	useEffect(() => {
		if (asset) {
			setValue('filename', asset.filename);
			setValue('description', asset.description);
		}
	});

	function onSubmit(values: any) {
		//console.log(values);

		let url= urls.asset.url;
		if (asset.id != null) {
			url = url + '/' + asset.id;
		}

		axios.put(url, values)
			.then(() => {
				if (isFunction(onAfterSave)) {
					onAfterSave();
				}
			}).catch(function (error) {
				console.log('axios error: ', error);
			}).finally(() => {
				if (isFunction(handleClose)) {
					handleClose();
				}
			}
		);
	}

	return (
		<form ref={form} onSubmit={handleSubmit(onSubmit)}>
			<div className="p-8">
				<div className="formItem">
					<label htmlFor="filename">File name</label>
					<input
						type="text"
						name="filename"
						id="filename"
						placeholder=""
						className={clsx(inputErrorClass(errors.filename))}
						{...register("filename", {required: true, maxLength: 255})}
					/>
				</div>

				<div className="formItem">
					<label htmlFor="description">Description</label>
					<textarea
						name="description"
						id="description"
						placeholder=""
						rows={4}
						className={clsx(inputErrorClass(errors.description))}
						{...register("description", {required: false, maxLength: 255})}
					/>
				</div>
			</div>

			<div className="px-8 py-6 bg-grey-100 text-right">
				<input type="submit" className="qbutton bg-white" disabled={isSubmitting} value="Save"/>
			</div>
		</form>
	);
}

export default AssetEdit;
